import { ACCESS_KEY } from '@app/api/auth';

export type JwtRole = {
  id?: number;
  name?: string;
};

export type JwtPayload = {
  role?: JwtRole;
  [key: string]: any;
};

const base64UrlDecode = (value: string): string => {
  const base64 = value.replace(/-/g, '+').replace(/_/g, '/');
  const decoded = atob(base64);
  return decodeURIComponent(
    decoded
      .split('')
      .map((char) => '%' + ('00' + char.charCodeAt(0).toString(16)).slice(-2))
      .join('')
  );
};

export const decodeJwt = (token: string): JwtPayload | null => {
  try {
    const payload = token.split('.')[1];
    if (!payload) {
      return null;
    }
    return JSON.parse(base64UrlDecode(payload));
  } catch (e) {
    return null;
  }
};

export const getTokenPayload = (): JwtPayload | null => {
  const token = localStorage.getItem(ACCESS_KEY);
  if (!token) {
    return null;
  }
  return decodeJwt(token);
};

export const getRoleName = (): string | undefined => getTokenPayload()?.role?.name;
